import { FC } from "react";
import { Button, HStack, Text } from "@chakra-ui/react";

import { useAppModal } from "../../../Modals";
import { MainPageSbpTransferModal } from "../Modal";
import { Info2Icon, ReloadIcon } from "../../../../icons";
import { formatPriceWithoutZeros, isStringWithNumber } from "../../../../../utils";

interface Props {
  amount: string | undefined;
  refetch: () => void;
}

export const MainPageSbpTransferInProgress: FC<Props> = ({ amount, refetch }) => {
  const { showModal } = useAppModal();

  const reloadStatus = () => {
    refetch();
  };

  const showInfo = () => {
    const formattedAmount = isStringWithNumber(amount) ? formatPriceWithoutZeros(Number(amount)) : "";
    const text = formattedAmount ? `Операция на сумму ${formattedAmount} в обработке` : "Операция в обработке";

    showModal({
      content: onClose => (
        <MainPageSbpTransferModal
          text={text}
          onClose={onClose}
        />
      ),
    });
  };

  return (
    <HStack mb="11px" justifyContent="space-between">
      <Text fontSize="14px">Операция в обработке</Text>

      <HStack spacing="4px">
        <Button minW="20px" h="20px" p="0" colorScheme="transparent" onClick={reloadStatus}>
          <ReloadIcon />
        </Button>

        <Button minW="20px" h="20px" p="0" colorScheme="transparent" onClick={showInfo}>
          <Info2Icon />
        </Button>
      </HStack>
    </HStack>
  );
};
